import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TokenService } from '@services/rest/token.service';
import { PaymentApiService } from '@services/rest/payment-api.service';
import { InvoiceModel } from '@model/invoice.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FpxBankModel, FpxGenerateRequestModel, HlbGetTokenRequestModel, MbbQrModel } from '@model/payment.mode';
import { HttpParams } from '@angular/common/http';
import { InvoiceApiService } from '@services/rest/invoice-api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize } from 'rxjs';
import { NzTabPosition } from 'ng-zorro-antd/tabs';


@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
    standalone: false
})
export class PaymentComponent implements OnInit {

  qrBase64 = ''; // initial QR value
  showOverlay = true;
  countdownTimer: any;
  form: FormGroup;
  countdownValue  = 0; // Countdown seconds
  countdownInterval: any;
  paymentCheckInterval: any;
  invoiceModel: InvoiceModel={};
  tabPosition: NzTabPosition = 'left';

  hlbGetTokenRequestModel: HlbGetTokenRequestModel={};
  invoiceReferenceNumber: string = "";
  txnReferenceNumber: string = "";
  mbbQrModel: MbbQrModel = {};
  submitted: boolean = false;

  bankList: FpxBankModel[] = [];
  fpxGenerateRequestModel: FpxGenerateRequestModel ={};
  isVisible = false;
  modalTitle: string ="";
  line1: string ="";
  line2: string ="";
  line3: string ="";
  selectedBank: string | null = null;
  dontTriggerBankChange: boolean = false;
  isMbbDisabled: boolean = true;
  isPbbDisabled: boolean = true;

  constructor(

    private router: Router,
    private formBuilder: FormBuilder,
    private notification: NzNotificationService,
    private paymentApiService: PaymentApiService,
    private invoiceApiService: InvoiceApiService,
    private route: ActivatedRoute,
    private messageService: NzMessageService,
    private spinner: NgxSpinnerService,
  ) 
  { 
    this.form = this.formBuilder.group({
      bank:[],      
      isChecked: [false],
      mbb:[],
      pbb:[],
      epp:[]
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (typeof window !== 'undefined') {
      this.updateTabPosition(window.innerWidth);
    }
  }

  private updateTabPosition(viewportWidth: number): void {
    this.tabPosition = viewportWidth < 768 ? 'top' : 'left';
  }

  ngOnInit(): void {
    this.form.reset();       
    if (typeof window !== 'undefined') {
      this.updateTabPosition(window.innerWidth);
    }

    this.route.queryParams
    .subscribe(params => { 

      if(params.ref != "" && params.ref != null)
      {   
        this.spinner.show();   
        this.getFpxBankList();
        this.invoiceReferenceNumber = params.ref;
        this.getInvoice();
      }
      else{
        this.showNotification("Invalid reference number",false);      
      }
    });
  }

  getFpxBankList() {
    if(!this.bankList || this.bankList.length === 0)
    {
      this.paymentApiService.getFpxBankList().subscribe(response => {
        this.bankList = response;
        this.isMbbDisabled = this.bankList.some(bank => bank.key === 'MB2U0227' && bank.isOffline);
        this.isPbbDisabled = this.bankList.some(bank => bank.key === 'PBB0233' && bank.isOffline);


        this.bankList = this.bankList.filter(
          (item: any) => item.key !== 'MB2U0227' && item.key !== 'PBB0233'
        );
      });
    }
  }

  startCountdown() {
    this.showOverlay = false;

     // Clear existing timers
    clearTimeout(this.countdownTimer);
    clearInterval(this.countdownInterval);
    clearInterval(this.paymentCheckInterval); // <-- clear polling

    // Reset countdown
    this.countdownValue = 60;


    setTimeout(() => {
      // Start polling every 4 seconds
      this.paymentCheckInterval = setInterval(() => {
        this.checkMbbQrTransactionStatus();
      }, 4000);
    }, 6000); // Wait 6 seconds before starting polling

    // Start countdown interval
    this.countdownInterval = setInterval(() => {
      this.countdownValue--;

      if (this.countdownValue <= 0) {
        clearInterval(this.countdownInterval);
        clearInterval(this.paymentCheckInterval); // Stop polling if time's up
      }
    }, 1000);

    // Timer to show overlay after 60 seconds
    this.countdownTimer = setTimeout(() => {
      this.showOverlay = true;
    }, 60000);
  }

  showNotification(message,status){
    if(status === true){
        this.messageService.success(message); 
    }
    else{
        this.messageService.error(message, {
          nzDuration: 8000});
    }
  }

  ngOnDestroy() {
    // Clean up timers
    clearTimeout(this.countdownTimer);
    clearInterval(this.countdownInterval);
    clearInterval(this.paymentCheckInterval);
  }

  getInvoice() {
      this.invoiceApiService.getInvoice(this.invoiceReferenceNumber)
        .pipe(
          finalize(() => {
            this.spinner.hide();
            })
        )
        .subscribe(response => {
          if(!response.success)
          {
            this.showNotification(response.errorMessage, false);
            this.router.navigate(['/']);
          }
          else{
            this.invoiceModel = response.entity;
          }

        }, error => {
          this.showNotification("Invalid Reference Number", false);
        });
  }

  creditCardPayment(){
    this.hlbGetTokenRequestModel.referenceNumber = this.invoiceReferenceNumber;
    this.hlbGetTokenRequestModel.type = 0; //retail
    this.getHlbToken();
  }

  
  eppPayment(){
    if(this.form.get('epp').value == null || this.form.get('epp').value == ""){
      this.showNotification("Please select a payment plan", false);
      return;
    }

    this.hlbGetTokenRequestModel.referenceNumber = this.invoiceReferenceNumber;
    this.hlbGetTokenRequestModel.type = Number(this.form.get('epp').value); 
    this.getHlbToken();
  }

  getHlbToken() {
        this.paymentApiService.getHlbToken(this.hlbGetTokenRequestModel)
        .subscribe(response => {
          if (response.success) {
              var token = response.entity;

              // Create a hidden form
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = 'https://ecomm-ah.hlb.com.my/pay/api/payment/v1/window/paymentWindow/';
              form.style.display = 'none';

              // Create the token input field
              const tokenInput = document.createElement('input');
              tokenInput.type = 'hidden';
              tokenInput.name = 'token';
              tokenInput.value = token;
              form.appendChild(tokenInput);
              
              // Append and submit the form
              document.body.appendChild(form);
              form.submit();

          } else {
            this.notification.error(response.errorMessage, "");
          }
      });
  }

  getMbbQr() {
     this.paymentApiService.getMbbQr(this.invoiceReferenceNumber)
    .subscribe(response => {
      if (response.success) {
        this.mbbQrModel = response.entity;
        this.qrBase64 = 'data:image/png;base64,' + this.mbbQrModel.qrImageBase64;
        this.startCountdown();
      }
    });
  }

  checkMbbQrTransactionStatus() {
    this.paymentApiService.getMbbQrTransactionStatus(this.mbbQrModel.transactionReferenceNo).subscribe(response => {
      if (response.success) {
        if(response.entity == "Failed")
        {
          clearInterval(this.countdownInterval);
          clearInterval(this.paymentCheckInterval);
          clearTimeout(this.countdownTimer);

          // Do something like redirect or show success
          this.showOverlay = true;
          this.showNotification("Payment failed",true);
          this.ngOnInit();
        }
        else if(response.entity == "Success")
        {
          clearInterval(this.countdownInterval);
          clearInterval(this.paymentCheckInterval);
          clearTimeout(this.countdownTimer);

          // Do something like redirect or show success
          this.showOverlay = true;
          this.showNotification("Successfully made payment",true);
          this.ngOnInit();
        }
      }
    });
  }

  onTabChange(index: number): void {
    if(index == 1)
    {

    }
  }
  
  get f(): { [key: string]: AbstractControl; } {
    return this.form.controls;
  }

  fpxPayment(){

    if(!this.form.get('isChecked')?.value)
    {
      this.showNotification("Please check on the T&C before proceed to payment.",false)
      return;
    }

    // if(this.invoiceModel.total < 1)
    // {
    //   this.showNotification("Transaction Amount is Lower than the Minimum Limit RM1.00 for B2C",false)
    //   return;
    // }

    this.fpxGenerateRequestModel.referenceNumber = this.invoiceReferenceNumber;
    this.fpxGenerateRequestModel.bankId = this.selectedBank;

    this.paymentApiService.generateFpxRequest(this.fpxGenerateRequestModel)
      .subscribe(response => {
          if (response.success) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = response.entity.url;

            Object.entries(response.entity.fpxForm).forEach(([key, value]) => {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = key;
              input.value = String(value ?? '');;
              form.appendChild(input);
            });
            
            console.log(form)
            document.body.appendChild(form);
            form.submit(); 
          }
      });
  }



  handleOk(): void {
    this.isVisible = false;
  }

  showModal(modalType: string ): void {
    this.isVisible = true;
    this.modalTitle = "Privacy Policy";
    this.line1 = "In line with the Personal Data Protection Act 2010 (PDPA), we seek your consent as our customer to be given to us to use, process and/or retain your personal data. In short, PDPA protects your personal data. We would like to seek your full co‐operation to grant us your consent by completing this Personal Data Protection";
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  isChubbSelected(){
    return this.invoiceModel.invoiceDetails?.some(detail =>
      detail.description?.toLowerCase().includes("chubb")
    );
  }

  isGeneraliSelected(){
    return this.invoiceModel.invoiceDetails?.some(detail =>
      detail.description?.toLowerCase().includes("generali")
    );
  }

  isZurichSelected(){
    return this.invoiceModel.invoiceDetails?.some(detail =>
      detail.description?.toLowerCase().includes("zurich")
    );
  }

  isTuneSelected(){
    return this.invoiceModel.invoiceDetails?.some(detail =>
      detail.description?.toLowerCase().includes("tune")
    );
  }

  isKurniaSelected(){
    return this.invoiceModel.invoiceDetails?.some(detail =>
      detail.description?.toLowerCase().includes("kurnia")
    );
  }

  downloadReceipt()
  {
      this.invoiceApiService.downloadReceipt(this.invoiceReferenceNumber,'Receipt').subscribe(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Receipt-${this.invoiceModel.orderNo}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }, error => {
        console.error('Failed to download PDF', error);
        alert('Failed to download invoice PDF');
      });
  }

  onBankClick(bankId: string) {
    if(bankId == 'PBB0233'){
      this.form.get('mbb')?.reset(null); 

    }
    else{
      this.form.get('pbb')?.reset(null);
    }

    this.selectedBank = bankId;
    this.dontTriggerBankChange = true; // Prevent triggering onBankChange
    this.form.get('bank')?.setValue(null, { emitEvent: false });
  }

  onBankChange(bankId: string){
    if (this.dontTriggerBankChange) {
      this.dontTriggerBankChange = false; // Reset flag
      return; // Skip this change event
    }

    this.selectedBank = bankId;
    this.form.get('mbb')?.reset(null); 
    this.form.get('pbb')?.reset(null);
  }

  allowMbbQr(){
    return this.invoiceModel.allowMbbQr;
  }

  allowHlbEpp(){
    return this.invoiceModel.allowHlbEpp;
  }

  allowHlbCreditcard(){
    return this.invoiceModel.allowHlbCreditcard;
  }

  allowHlb12MonthsEpp(){
    return this.invoiceModel.allowHlb12MonthsEpp;
  }
  

  getAgencyName(){
    if(this.isZurichSelected())
      return "Services provided by BMS Road Tax( 202003383922 / 003219451-V )";
    else if(this.isChubbSelected())
      return "Services provided by Lim Siew Tin( 202403302283 / 003668786-K )";
    else if(this.isGeneraliSelected() || this.isKurniaSelected())
      return "Services provided by Brilliant Management Services( 199803074892 / 001166576-D )";
    else if(this.isTuneSelected())
      return "Services provided by Passion Agency( 200103091272 / 001312509-P )";
    else
      return "Services provided by BMS Road Tax( 202003383922 / 003219451-V )";
  }


}



